export default __webpack_public_path__ + "static/media/A97.72aac73f.png";